<div class="px-4 py-7">
  <div class="flex flex-grow flex-row items-start gap-5">
    <!-- Title -->
    <div class="mb-6 flex flex-grow items-start">
      <aux-icon name="Checkbox" class="mr-2.5" />
      <h3 class="quarter-close-checklist-title">
        {{ quarterCloseChecklistTitle$(workflowList) | async }}
      </h3>
    </div>

    <!-- Month Dropdown -->
    <div class="mb-6 flex flex-row items-center">
      <span class="mr-2">Select Month</span>
      <ng-select
        #selectMonthEl
        class="month-select w-64"
        [multiple]="false"
        [clearable]="false"
        [formControl]="selectedQuarterMonthFormControl"
        [items]="quarterMonths"
        bindValue="value"
        bindLabel="label"
      >
        <ng-template let-item="item" ng-option-tmp>
          <div
            (click)="selectMonth($event, item.value, item.disabled)"
            [title]="item.label"
            class="option-wrapper text-sm"
          >
            {{ item.label }}
          </div>
        </ng-template>
      </ng-select>
    </div>
    <!-- Export Button -->
    <div class="mb-6 flex justify-between">
      <div class="flex items-center">
        <div *ngVar="isBtnLoading('export') | async as isExportProcessing" class="col-span-1">
          <aux-export-excel-button
            className="ml-1"
            [clickFN]="onExportChecklist.bind(this)"
            [loading]="isExportProcessing"
            [disabled]="isExportProcessing"
            [spinnerSize]="7"
            pendoTag="quarter-close-checklist-excel-export-button"
          />
        </div>
      </div>
    </div>
  </div>

  <!-- Section: Gather Documents -->
  <div class="relative">
    <!-- Loader -->
    @if (isLoadingList) {
      <div class="checklist-container-disabled absolute h-full w-full">
        <div class="spinner m-auto mt-40 h-32 w-32 border-8"></div>
      </div>
    }

    <div class="checklist-container mb-8">
      <!-- Title -->
      <aux-checklist-row-title
        icon="Files"
        pendoID="checklist-gather-docments-lock-all"
        [title]="sectionTitles.GatherDocuments"
        [total]="utils.sectionTotals(sections.GatherDocuments, workflowList)"
        [complete]="utils.sectionCompletedTotals(sections.GatherDocuments, workflowList)"
        (lockAllEmit)="lockAllWorkflows(sections.GatherDocuments)"
        [isLoadingList]="isLoadingList"
        [disabledLock]="
          (!isAdminUser &&
            utils.isAnyWorkflowUnlockedAndHasNoPermissions(
              sections.GatherDocuments,
              workflowList,
              permissionList()
            )) ||
          isClosedMonthsProcessing ||
          !isCurrentQuarterSelected ||
          isLockingAll ||
          isPastQuarterMonth
        "
      />

      <!-- Pending Change Orders, Purchase Orders, New Vendor Contracts, or Budgets -->
      <aux-checklist-row-info
        [title]="rowTitles.GatherContracts"
        [checklistComponent]="rowComponents.GatherContracts"
        [rowId]="rows.GatherContracts"
        [disabledLock]="isClosedMonthsProcessing || !isCurrentQuarterSelected || isPastQuarterMonth"
        [workflow]="utils.workflow(rowTitles.GatherContracts, workflowList)"
        [open]="checklistToggleQuery.isRowOpen(rows.GatherContracts)()"
        [addPoReportUploadClick]="onAddPoReportUploadClick"
        [changeLockStatus]="changeLockStatus"
        [hasUserPermissions]="permissionList().userHasChecklistContractsPermission"
        [isPastQuarterMonth]="isPastQuarterMonth"
        [checklistAdminPermission]="permissionList().userHasChecklistAdminPermission"
        [permissionType]="PermissionType.PERMISSION_CHECKLIST_CONTRACTS"
      />

      <!-- Review Invoices -->
      <aux-checklist-row-info
        [title]="rowTitles.GatherInvoices"
        [rowId]="rows.GatherInvoices"
        [selectedMonth]="selectedQuarterMonthFormControl.value"
        [disabledLock]="isClosedMonthsProcessing || !isCurrentQuarterSelected || isPastQuarterMonth"
        [workflow]="utils.workflow(rowTitles.GatherInvoices, workflowList)"
        [open]="checklistToggleQuery.isRowOpen(rows.GatherInvoices)()"
        [changeLockStatus]="changeLockStatus"
        [hasUserPermissions]="permissionList().userHasChecklistInvoicesPermission"
        [isPastQuarterMonth]="isPastQuarterMonth"
        [checklistAdminPermission]="permissionList().userHasChecklistAdminPermission"
        [permissionType]="PermissionType.PERMISSION_CHECKLIST_INVOICES"
      >
        <aux-checklist-row-info-gather-invoices
          [isLoadingList]="isLoadingList"
          [numberOfInvoices]="numberOfInvoices"
          [amountInvoiced]="amountInvoiced"
        />
      </aux-checklist-row-info>

      <!-- Review Vendor Estimates -->
      <aux-checklist-row-info
        [title]="rowTitles.GatherEstimates"
        [checklistComponent]="rowComponents.GatherEstimates"
        [rowId]="rows.GatherEstimates"
        [disabledLock]="isClosedMonthsProcessing || !isCurrentQuarterSelected || isPastQuarterMonth"
        [workflow]="utils.workflow(rowTitles.GatherEstimates, workflowList)"
        [open]="checklistToggleQuery.isRowOpen(rows.GatherEstimates)()"
        [vendorEstimateUploadClick]="onAddVendorEstimateUploadClick"
        [vendorEstimateSummaries]="vendorEstimateSummaries"
        [changeLockStatus]="changeLockStatus"
        [hasUserPermissions]="permissionList().userHasChecklistVendorEstimatesPermission"
        [isPastQuarterMonth]="isPastQuarterMonth"
        [checklistAdminPermission]="permissionList().userHasChecklistAdminPermission"
        [permissionType]="PermissionType.PERMISSION_CHECKLIST_VENDOR_ESTIMATES"
        (toggleOpened)="reviewVendorEstimateOpened()"
      />

      <!-- Confirm Investigator Data -->
      <aux-checklist-row-info
        id="checklistInvestigator"
        [title]="rowTitles.GatherPatients"
        [checklistComponent]="rowComponents.GatherPatients"
        [queryParams]="selectedPeriodQuery()"
        [rowId]="rows.GatherPatients"
        [disabledLock]="isClosedMonthsProcessing || !isCurrentQuarterSelected || isPastQuarterMonth"
        [workflow]="utils.workflow(rowTitles.GatherPatients, workflowList)"
        [open]="checklistToggleQuery.isRowOpen(rows.GatherPatients)()"
        [changeLockStatus]="changeLockStatus"
        [hasUserPermissions]="permissionList().userHasChecklistPatientDataPermission"
        [isPastQuarterMonth]="isPastQuarterMonth"
        [checklistAdminPermission]="permissionList().userHasChecklistAdminPermission"
        [permissionType]="PermissionType.PERMISSION_CHECKLIST_PATIENT_DATA"
        [detailRowContainerClassName]="'checklist-row-info-detail-container w-full mt-4 py-1 px-4'"
      />
    </div>
  </div>

  <!-- Section: Confirm Forecast -->
  <div class="relative">
    <!-- Loader -->
    @if (isLoadingList) {
      <div class="checklist-container-disabled absolute h-full w-full">
        <div class="spinner m-auto mt-28 h-32 w-32 border-8"></div>
      </div>
    }

    <div class="checklist-container mb-8">
      <!-- Title -->
      <aux-checklist-row-title
        icon="ChartBar"
        pendoID="checklist-confirm-forecast-lock-all"
        [title]="sectionTitles.ConfirmForecast"
        [total]="utils.sectionTotals(sections.ConfirmForecast, workflowList)"
        [complete]="utils.sectionCompletedTotals(sections.ConfirmForecast, workflowList)"
        (lockAllEmit)="lockAllWorkflows(sections.ConfirmForecast)"
        [isLoadingList]="isLoadingList"
        [disabledLock]="
          (!isAdminUser &&
            utils.isAnyWorkflowUnlockedAndHasNoPermissions(
              sections.ConfirmForecast,
              workflowList,
              permissionList()
            )) ||
          isClosedMonthsProcessing ||
          !isCurrentQuarterSelected ||
          isLockingAll ||
          isPastQuarterMonth
        "
      />

      <!-- Confirm Trial Timeline -->
      <aux-checklist-row-info
        [title]="rowTitles.ForecastTimeline"
        [rowId]="rows.ForecastTimeline"
        [disabledLock]="isClosedMonthsProcessing || !isCurrentQuarterSelected || isPastQuarterMonth"
        [workflow]="utils.workflow(rowTitles.ForecastTimeline, workflowList)"
        [open]="checklistToggleQuery.isRowOpen(rows.ForecastTimeline)()"
        [changeLockStatus]="changeLockStatus"
        [hasUserPermissions]="permissionList().userHasChecklistTrialTimelinePermission"
        [isPastQuarterMonth]="isPastQuarterMonth"
        [checklistAdminPermission]="permissionList().userHasChecklistAdminPermission"
        [permissionType]="PermissionType.PERMISSION_CHECKLIST_TRIAL_TIMELINE"
        [customRoute]="trialTimelineRoute"
      />

      <!-- Site, Patient, & Custom Curves -->
      <aux-checklist-row-info
        [title]="rowTitles.ForecastCurves"
        [rowId]="rows.ForecastCurves"
        [disabledLock]="isClosedMonthsProcessing || !isCurrentQuarterSelected || isPastQuarterMonth"
        [workflow]="utils.workflow(rowTitles.ForecastCurves, workflowList)"
        [open]="checklistToggleQuery.isRowOpen(rows.ForecastCurves)()"
        [changeLockStatus]="changeLockStatus"
        [hasUserPermissions]="permissionList().userHasChecklistPatientSiteCurvePermission"
        [isPastQuarterMonth]="isPastQuarterMonth"
        [checklistAdminPermission]="permissionList().userHasChecklistAdminPermission"
        [permissionType]="PermissionType.PERMISSION_CHECKLIST_PATIENT_SITE_CURVES"
      />

      <!-- Forecast Methodology -->
      <aux-checklist-row-info
        [title]="rowTitles.ForecastMethodology"
        [rowId]="rows.ForecastMethodology"
        [disabledLock]="isClosedMonthsProcessing || !isCurrentQuarterSelected || isPastQuarterMonth"
        [workflow]="utils.workflow(rowTitles.ForecastMethodology, workflowList)"
        [open]="checklistToggleQuery.isRowOpen(rows.ForecastMethodology)()"
        [changeLockStatus]="changeLockStatus"
        [hasUserPermissions]="permissionList().userHasChecklistForecastMethodologyPermission"
        [isPastQuarterMonth]="isPastQuarterMonth"
        [customRoute]="forecastMethodologyRoute"
        [checklistAdminPermission]="permissionList().userHasChecklistAdminPermission"
        [permissionType]="PermissionType.PERMISSION_CHECKLIST_FORECAST_METHODOLOGY"
      />
    </div>
  </div>

  <!-- Section: Confirm and Close -->
  <div class="relative">
    <!-- Loader -->
    @if (isLoadingList) {
      <div class="checklist-container-disabled absolute h-full w-full">
        <div class="spinner m-auto mt-28 h-32 w-32 border-8"></div>
      </div>
    }

    <div class="checklist-container mb-8">
      <!-- Title -->
      <aux-checklist-row-title
        icon="FileCheck"
        pendoID="checklist-confirm-close-lock-all"
        [title]="sectionTitles.ConfirmClose"
        [total]="utils.sectionTotals(sections.ConfirmClose, workflowList)"
        [complete]="utils.sectionCompletedTotals(sections.ConfirmClose, workflowList)"
        (lockAllEmit)="lockAllWorkflows(sections.ConfirmClose)"
        [isLoadingList]="isLoadingList"
        [disabledLock]="
          (!isAdminUser &&
            utils.isAnyWorkflowUnlockedAndHasNoPermissions(
              sections.ConfirmClose,
              workflowList,
              permissionList()
            )) ||
          isClosedMonthsProcessing ||
          !isCurrentQuarterSelected ||
          isLockingAll ||
          !gatherDocumentsSectionComplete ||
          !confirmForecastSectionComplete ||
          isPastQuarterMonth
        "
        [tooltip]="
          utils.disabledLockTooltip(
            sections.ConfirmClose,
            isClosedMonthsProcessing ||
              !isCurrentQuarterSelected ||
              !gatherDocumentsSectionComplete ||
              !confirmForecastSectionComplete
          )
        "
      />

      <!-- Confirm Vendor Expenses -->
      <aux-checklist-row-info
        [title]="rowTitles.CloseExpenses"
        [rowId]="rows.CloseExpenses"
        [disabledLock]="
          isClosedMonthsProcessing ||
          !isCurrentQuarterSelected ||
          !gatherDocumentsSectionComplete ||
          !confirmForecastSectionComplete ||
          isPastQuarterMonth
        "
        [tooltip]="
          utils.disabledLockTooltip(
            rows.CloseExpenses,
            isClosedMonthsProcessing ||
              !isCurrentQuarterSelected ||
              !gatherDocumentsSectionComplete ||
              !confirmForecastSectionComplete
          )
        "
        [workflow]="utils.workflow(rowTitles.CloseExpenses, workflowList)"
        [open]="checklistToggleQuery.isRowOpen(rows.CloseExpenses)()"
        [customRoute]="vendorExpensesRoute"
        [changeLockStatus]="changeLockStatus"
        [hasUserPermissions]="permissionList().userHasChecklistVendorExpensesPermission"
        [isPastQuarterMonth]="isPastQuarterMonth"
        [checklistAdminPermission]="permissionList().userHasChecklistAdminPermission"
        [permissionType]="PermissionType.PERMISSION_CHECKLIST_VENDOR_EXPENSES"
      />

      <!-- Confirm Discounts -->
      <aux-checklist-row-info
        [title]="rowTitles.CloseDiscounts"
        [rowId]="rows.CloseDiscounts"
        [checklistComponent]="rowComponents.CloseDiscounts"
        [disabledLock]="
          isClosedMonthsProcessing ||
          !isCurrentQuarterSelected ||
          !gatherDocumentsSectionComplete ||
          !confirmForecastSectionComplete ||
          !closeExpensesRowComplete ||
          isPastQuarterMonth
        "
        [tooltip]="
          utils.disabledLockTooltip(
            rows.CloseDiscounts,
            isClosedMonthsProcessing ||
              !isCurrentQuarterSelected ||
              !gatherDocumentsSectionComplete ||
              !confirmForecastSectionComplete ||
              !closeExpensesRowComplete
          )
        "
        [workflow]="utils.workflow(rowTitles.CloseDiscounts, workflowList)"
        [open]="checklistToggleQuery.isRowOpen(rows.CloseDiscounts)()"
        [changeLockStatus]="changeLockStatus"
        [detailRowContainerClassName]="''"
        [hasUserPermissions]="permissionList().userHasChecklistDiscountsPermission"
        [isPastQuarterMonth]="isPastQuarterMonth"
        [checklistAdminPermission]="permissionList().userHasChecklistAdminPermission"
        [permissionType]="PermissionType.PERMISSION_CHECKLIST_DISCOUNTS"
      />
    </div>
  </div>
</div>

@if (isCurrentQuarterSelected && isSelectedMonthOpen()) {
  <aux-checklist-banner [disabled]="isChecklistBannerDisabled()" />
}
